import { Document } from '@tiptap/extension-document';
import { Fragment, Slice } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';

/** One internal paragraph keeps Heading authoring inline-only while native alignment targets a block. */
export const headingDocument = Document.extend({
  content: 'paragraph',
  addKeyboardShortcuts() {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Tiptap names keyboard shortcuts by key.
    return { Enter: () => this.editor.commands.setHardBreak() };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          // Keep pasted blocks as lines in the one-paragraph heading rather than dropping later blocks.
          transformPasted: (slice) => {
            const textBlocks: Array<typeof slice.content.content[number]> = [];
            slice.content.descendants((node) => {
              if (node.isTextblock) {
                textBlocks.push(node);
                return false;
              }
              return true;
            });
            if (textBlocks.length <= 1) {
              return slice;
            }

            const [firstBlock] = textBlocks;
            const { schema } = firstBlock.type;
            const inlineContent = textBlocks.flatMap((block, index) => [
              ...(index === 0 ? [] : [schema.nodes.hardBreak.create()]),
              ...block.content.content,
            ]);
            const paragraph = schema.nodes.paragraph.create(null, Fragment.fromArray(inlineContent));
            return new Slice(Fragment.from(paragraph), 0, 0);
          },
        },
      }),
    ];
  },
});
